import PropTypes from 'prop-types';
import { PropTypes as MobxPropTypes } from 'mobx-react';
import { action, extendObservable, reaction } from 'mobx';
import { apiCall } from '../API';
import AsyncActionStore from './AsyncActionStore';
import FlagStore from './FlagStore';
import InputStore from './InputStore';

export default class ConsoleCustomerSelectStore {
    static PropType = PropTypes.shape({
        apiSetState: AsyncActionStore.PropType.isRequired,
        customerId: PropTypes.number.isRequired,
        realCustomerId: PropTypes.number.isRequired,
        filteredCustomerList: MobxPropTypes.arrayOrObservableArrayOf(PropTypes.shape({
            id: PropTypes.number.isRequired,
            displayName: PropTypes.string.isRequired,
        })).isRequired,
        dropdown: FlagStore.PropType.isRequired,
        focus: FlagStore.PropType.isRequired,
        filter: InputStore.PropType.isRequired,
        setSelectedCustomer: PropTypes.func.isRequired,
        setFocusClearHoveredAndClose: PropTypes.func.isRequired,
        setHovered: PropTypes.func.isRequired,
        toggleList: PropTypes.func.isRequired,
    });

    constructor(data = {}) {
        extendObservable(this, /** @class ConsoleCustomerSelectStore */{
            apiSet: apiCall('/console_admin_api/customer_id_override/set'),
            apiClear: apiCall('/console_admin_api/customer_id_override/clear'),
            apiSetState: new AsyncActionStore(),
            customerId: 0,
            realCustomerId: 0,
            customerList: [],
            dropdown: new FlagStore(false),
            focus: new FlagStore(false),
            hovered: null,
            filter: new InputStore({ value: '' }),
            isStorybook: false,

            get filteredCustomerList() {
                const filter = this.filter.value.toLowerCase();
                return this.customerList
                    .filter((customer) => (!filter
                        || (customer.displayName.toLowerCase().indexOf(filter) !== -1)
                        || ((customer.id + '') === filter)))
                    .sort((a, b) => a.displayName.localeCompare(b.displayName) || (a.id - b.id));
            },

            get customerName() {
                const foundCustomer = this.customerList.find((c) => c.id === this.customerId);
                return foundCustomer.displayName || '';
            },

        }, data);

        reaction(() => this.dropdown.value,
            (isOpen) => isOpen && setTimeout(this.filter.focus));
    }

    toggleList = action(() => {
        this.dropdown.toggle();
        this.focus.setFalse();
        this.filter.setValue('');
        this.hovered = null;
    });

    setHovered = action((newValue) => {
        if (newValue >= this.filteredCustomerList.length || newValue < 0) {
            return;
        }
        this.hovered = newValue;
    });

    setSelectedCustomer = action((id) => {
        if (this.apiSetState.isLoading || (id === null && this.hovered === null)) {
            return;
        }

        if (id === null) {
            const foundCustomer = this.filteredCustomerList.find((c, index) => index === this.hovered);
            if (!foundCustomer) {
                return;
            }
            id = foundCustomer.id;
        }

        if (id === this.customerId) {
            this.dropdown.close();
            return;
        }

        this.dropdown.close();
        this.hovered = null;
        this.apiSetState.setLoading();

        if (this.isStorybook) {
            this.customerId = id;
            this.apiSetState.setBase();
            return;
        }

        this.apiSet(id)
            .then(() => window.location.reload());
    });

    setFocusClearHoveredAndClose = action((focus) => {
        this.dropdown.close();
        this.focus.setValue(focus);
        this.hovered = null;
    });
}
